<template>
  <action-dropdown
    id="list-action-dropdown"
    ref="dropdown"
    :label="$attrs.label"
    :position="$attrs.position"
  >
    <slot></slot>
  </action-dropdown>
</template>

<script>
import ActionDropdown from '../Shared/ActionDropdown.vue';

export default {
  components: {
    ActionDropdown
  },
  inheritAttrs: false,
  props: {
    revealedAction: {
      type: String,
      default: null
    }
  },
  watch: {
    revealedAction() {
      this.$refs.dropdown.close();
    }
  }
};
</script>
